<template>
	<div class="tl" style="background-color: #f5f5f5;min-height: 100vh;">
		<van-nav-bar  left-arrow @click-left="onClickLeft"/>		
		<!-- 选择自提点 -->
		<van-cell  is-link @click="getBranch" >
			<template #title>				
			    <span>{{branch.id ? branch.name :'请选择提货点'}}</span>
			    <span style="color:red;" v-if="!branch.id">*</span>
			</template>
		</van-cell>
		
		<div style="padding: 0 10px;margin-top: 10px;padding-bottom: 190px;">
		<!-- 赠品 -->
		<div v-if="giftItem.id"  style="margin-bottom: 15px;background-color: #ffffff;border-radius: 10px;padding: 10px 0;">
			<van-row style="padding: 0px 10px 10px 10px;" class="order-list-title">
				<van-col span="20" style="text-align:left;">
					<span style="font-size: 14px;">{{giftItem.name}}</span>						
				</van-col>
				<van-col span="4" style="text-align: right;">							
					<van-tag type="danger">满赠</van-tag>
				</van-col>
			</van-row>
			<van-card 
			v-for="(item,index) in giftItem.item_list"
			:key="index"
			  :num="item.gift_num"
			  tag="赠品"			
			  :desc="item.size"
			  :title="item.sub_name"
			  :thumb="item.thumb_image"
			 
			/>								  
		</div>
		<div v-for="(list,index) in carts" :key="index" style="margin-bottom: 15px;background-color: #ffffff;border-radius: 10px;padding: 10px 0;">
					  <van-row style="padding: 0px 10px 10px 10px;" class="order-list-title">
						<van-col span="20" style="text-align:left;">
							<span style="font-size: 14px;">{{list.category_name}}</span>						
						</van-col>
						<van-col span="4" style="text-align: right;">							
							<van-tag type="primary" v-if="list.is_presell == 2">{{list.tag}}</van-tag>
							<van-tag type="success" v-else>{{list.tag}}</van-tag>
						</van-col>
					  </van-row>				  
					  <van-row style="display: flex;padding: 0 20px;align-items: center; overflow: auto;" @click='getGoodsInfo(list)'>
							  <van-col span="6" v-for="(item,index) in list.item_list" :key="index">
								<van-image
								  width="80"
								  height="80"
								  :src="item.thumb_image"
								/>
							</van-col>
					 </van-row>									
				  <van-cell  is-link @click='openWrList(list)' style="margin-top: 10px;">
				  	<template #title>				
				  	    <span>{{list.pickTime ? list.pickTime.ymd_date + list.pickTime.week : '提货日期'}}</span>
				  	    <span style="color:red;" v-if="!list.pickTime">*</span>
				  	</template>
				  </van-cell>
				<!-- 备注信息 -->
					<van-field
					  v-model="list.attach"
					  rows="1"
					  autosize
					  label="备注信息"
					  type="textarea"
					  placeholder="请输入需要注明的信息"
					  
					  maxlength='40'
					/>
			</div>
		</div>
		<!-- 日历弹出框 -->
		<van-popup v-model="wrShow" position="bottom"  closeable>
			<div style="text-align: center;">
				<div class="wr-title">请选择提货时间</div>
				<van-button class="wr-button" v-for="(item,index) in partOrderDeliveryWr" :key="index" :disabled='!Boolean(item.wr_status)' @click="setWr(item)">{{item.ymd_date}} {{item.week}} <span v-if='!Boolean(item.wr_status)'>(非营业日期)</span></van-button>
			</div>			
		</van-popup>
		
		<div style="position: fixed;left: 0;bottom: 49px;width: 100%;background-color: #ffffff;padding: 4px 0;border-radius: 12px 12px 0 0;">
			<!-- 支付方式 -->
			<van-cell title="微信支付">
			  <template #right-icon>
			    <van-icon name="checked"  />
			  </template>
			</van-cell>
			<!-- 订单金额 -->
			<van-cell title="订单金额" :value="'￥'+lastTotalPrice"></van-cell>
			<!-- <van-cell v-if="reduceCount.reduction_amount" title="满减优惠" :value="'-￥'+reduceCount.reduction_amount" value-class="red-color" title-class="red-color"></van-cell> -->
			<!-- <van-cell title="折扣优惠" :value="'-￥'+(lastTotalPrice-discountPrice).toFixed(2)" v-if="lastTotalPrice-discountPrice" value-class="red-color" title-class="red-color"></van-cell> -->			
		</div>
		
		<!-- 自提点 -->
		<van-popup v-model="branchShow" round position="bottom" :style="{ height: '90%' }">
			<div>						
				<div v-if="branchs">
					<div style="font-size: 20px; text-align: center;width: 100%; color:#42C052;padding: 10px 0;">离我最近的自提点</div>
					<van-row @click="setBranch(item)"  v-for="(item,index) in branchs" :key="index" type="flex" style="text-align: left; padding: 10px;border-bottom: 1px solid #ccc;" >
					  <van-col span="17">
							<span class="van-ellipsis" style="font-weight: 700;">{{item.name}}</span>
						  </van-col>
					  <van-col  style="color:#42C052;flex: 1;text-align: right;">{{item.distance}} ></van-col>
					  <van-col span="24" class="van-ellipsis" style="color:#444;">地址:{{item.addr}}</van-col>
					</van-row>
				</div>
				
				<div v-else>获取位置失败，请授权位置权限</div>
				
			</div>
			
		</van-popup>
		<van-popup v-model="goodsInfoShow" round position="bottom" :style="{ height: '60%' }" >
			<div style="text-align: center;font-size: 18px;padding: 10px;">商品清单</div>
			<div style="padding-bottom: 20px;">
				<van-card
				v-for="(item,index) in currentPartOrder.item_list"
				:key="index"
				  :num="item.goods_num"
				  :price="item.vip_price.toFixed(2)"
				  :desc="item.unit_name"
				  :title="item.item_name"
				  :thumb="item.thumb_image"
				/>
			</div>
			
		</van-popup>
		<van-submit-bar :price="lastTotalPrice*100" button-text="支付订单" @submit="onSubmit"  :disabled='subDisabled'/>
	</div>
</template>

<script>
	import { mapState,mapActions} from 'vuex'
	
	import wx from "weixin-js-sdk";
	import { Toast } from 'vant'
	export default{
		name:"orderSubmit",
		computed:{
			...mapState(['branchs']),
			//优惠后金额
			// discountPrice(){
			// 	let total = (this.lastTotalPrice*this.discount).toFixed(2)
			// 	return total
			// },
			// giftItem(){
			// 	let obj = {}
			// 	if(!this.giftList){
			// 		obj = {}
			// 	}else{
			// 		let price = this.reductionGift == '1' ? this.lastTotalPrice : this.cartTotalPrice //1为满减优先					
			// 		let filterList = this.giftList.filter(item=> Number(price)  > Number(item.min_amount) )
			// 		if(filterList.length == 0){
			// 			obj = {}
			// 		}else{
			// 			obj = filterList[filterList.length-1]	
			// 		}					
			// 	}
			// 	console.log(obj)
			// 	return obj				 
			// },
		},
		data(){
			return{	
								
				lastTotalPrice :"",
				reductionGift:'',
				giftList :[],
				giftItem:{},				
				reduceCount:{},
				// branchs:[
				//   {
				//     "id": 70,
				//     "name": "西大营食迅惠民自提点",
				//     "addr": "西大营",
				//     "longitude": "116.261464",
				//     "latitude": "39.765185",
				//     "distance": "9m"
				//   },
				//   {
				//     "id": 9,
				//     "name": "复兴路第三供应点-复兴路22",
				//     "addr": "海淀区复兴路22号院",
				//     "longitude": "116.291137",
				//     "latitude": "39.901784",
				//     "distance": "15.4km"
				//   },
				//   {
				//     "id": 8,
				//     "name": "复兴路第二供应点-复兴路26",
				//     "addr": "海淀区复兴路26号院",
				//     "longitude": "116.281064",
				//     "latitude": "39.903568",
				//     "distance": "15.48km"
				//   },
				//   {
				//     "id": 10,
				//     "name": "复兴路第四供应点-复兴路20",
				//     "addr": "海淀区复兴路20号院",
				//     "longitude": "116.300044",
				//     "latitude": "39.904435",
				//     "distance": "15.83km"
				//   },
				//   {
				//     "id": 16,
				//     "name": "供应站-万寿路分店",
				//     "addr": "海淀区万寿路4号院",
				//     "longitude": "116.283678",
				//     "latitude": "39.91468",
				//     "distance": "16.73km"
				//   },
				//   {
				//     "id": 14,
				//     "name": "供应站-金沟河分店",
				//     "addr": "海淀区金沟河东路5号院1号楼西侧",
				//     "longitude": "116.280128",
				//     "latitude": "39.917921",
				//     "distance": "17.06km"
				//   },
				//   {
				//     "id": 52,
				//     "name": "海淀区56所",
				//     "addr": "海淀区万寿路甲5号院",
				//     "longitude": "116.29517",
				//     "latitude": "39.921751",
				//     "distance": "17.65km"
				//   },
				//   {
				//     "id": 71,
				//     "name": "海淀离52所（晾果厂丙25号院）",
				//     "addr": "海淀区玉渊潭公寓（玉渊潭公园南）晾果厂丙25号院",
				//     "longitude": "116.280049",
				//     "latitude": "39.924054",
				//     "distance": "17.74km"
				//   },
				//   {
				//     "id": 50,
				//     "name": "五棵松北8号院自提点-53所",
				//     "addr": "海淀区五棵松北8号院",
				//     "longitude": "116.283108",
				//     "latitude": "39.92525",
				//     "distance": "17.89km"
				//   },
				//   {
				//     "id": 46,
				//     "name": "定慧北里分店-49所",
				//     "addr": "海淀区定慧北里2号院",
				//     "longitude": "116.283977",
				//     "latitude": "39.925754",
				//     "distance": "17.96km"
				//   },
				//   {
				//     "id": 49,
				//     "name": "海淀离52所（10号院）",
				//     "addr": "海淀区阜成路友谊里10号院",
				//     "longitude": "116.328594",
				//     "latitude": "39.921438",
				//     "distance": "18.3km"
				//   },
				//   {
				//     "id": 44,
				//     "name": "47所",
				//     "addr": "海淀区玲珑路八里庄北里1号院",
				//     "longitude": "116.298706",
				//     "latitude": "39.937005",
				//     "distance": "19.37km"
				//   },
				//   {
				//     "id": 45,
				//     "name": "海淀区48离",
				//     "addr": "海淀区车公庄西路12号院",
				//     "longitude": "116.333918",
				//     "latitude": "39.93705",
				//     "distance": "20.09km"
				//   },
				//   {
				//     "id": 57,
				//     "name": "西二退",
				//     "addr": "西城区西四东大街43号院",
				//     "longitude": "116.381833",
				//     "latitude": "39.93036",
				//     "distance": "21.05km"
				//   },
				//   {
				//     "id": 5,
				//     "name": "旃坛寺第二供应点-1号院",
				//     "addr": "西城区爱民街1号院",
				//     "longitude": "116.38875",
				//     "latitude": "39.935242",
				//     "distance": "21.81km"
				//   },
				//   {
				//     "id": 6,
				//     "name": "旃坛寺第三供应点-爱民街",
				//     "addr": "西城区爱民街2号院",
				//     "longitude": "116.389918",
				//     "latitude": "39.938489",
				//     "distance": "22.17km"
				//   },
				//   {
				//     "id": 7,
				//     "name": "旃坛寺第五供应点-新外大街23",
				//     "addr": "海淀区新外大街新街口外大街23号院",
				//     "longitude": "116.370372",
				//     "latitude": "39.956283",
				//     "distance": "23.2km"
				//   },
				//   {
				//     "id": 38,
				//     "name": "海淀区第41离职干部休养所",
				//     "addr": "海淀区蓝靛厂路13号",
				//     "longitude": "116.293541",
				//     "latitude": "39.974489",
				//     "distance": "23.43km"
				//   },
				//   {
				//     "id": 15,
				//     "name": "供应站-新康街分店",
				//     "addr": "西城区新康街1号院东侧",
				//     "longitude": "116.374902",
				//     "latitude": "39.958306",
				//     "distance": "23.56km"
				//   },
				//   {
				//     "id": 11,
				//     "name": "黄寺第二供应点-黄寺27",
				//     "addr": "西城区黄寺27号院",
				//     "longitude": "116.381077",
				//     "latitude": "39.9631",
				//     "distance": "24.26km"
				//   },
				//   {
				//     "id": 13,
				//     "name": "黄寺第四供应点-安德里",
				//     "addr": "东城区安德里北街21号院东院",
				//     "longitude": "116.397205",
				//     "latitude": "39.957316",
				//     "distance": "24.31km"
				//   },
				//   {
				//     "id": 12,
				//     "name": "黄寺第三供应点-黄寺乙1",
				//     "addr": "东城区黄寺乙1号院",
				//     "longitude": "116.39415",
				//     "latitude": "39.962644",
				//     "distance": "24.71km"
				//   },
				//   {
				//     "id": 36,
				//     "name": "苏州街港沟15号院自提点（39所）",
				//     "addr": "海淀区苏州街港沟路15号院",
				//     "longitude": "116.309431",
				//     "latitude": "39.987695",
				//     "distance": "25.08km"
				//   },
				//   {
				//     "id": 2,
				//     "name": "西山第一供应点-厢红旗",
				//     "addr": "海淀区遗光寺路厢红旗030大院",
				//     "longitude": "116.252023",
				//     "latitude": "40.012737",
				//     "distance": "27.54km"
				//   }
				// ],
				
				subDisabled:false,
				wrShow:false,//取货日期弹出框				
				carts:[],
				ids:[],
				cartTotalPrice:'',//总计金额				
				branchShow:false,//自提点列表弹窗
				branch:{},//已选择的提货点
				deliveryWr:{},//提货日历合集
				partOrderDeliveryWr:[],//当前活动的提货日历
				currentPartOrder:{} ,//当前设置取货日期和备注的分订单
				discount:1,//默认的折扣是1
				goodsInfoShow:false,
				
				
			}
		},
		methods:{
			...mapActions(['actOrderAsync',]),
			onClickLeft(){
				this.$router.go(-1)
			},
			
			//打开提货点列表
			getBranch(){
				this.branchShow = true
				this.$wxLocation()		
			},
			//选择提货点
			setBranch(item){
				this.partOrderDeliveryWr =[] //重置当前提货日历
				this.branchShow = false
				this.branch = item
				this.getDeliveryWr() //获取提货日历合集
			},
			//打开日历弹窗
			openWrList(item){			
				this.partOrderDeliveryWr =[] //先清空				
				this.currentPartOrder = item //当前分订单
				if(this.branch.id){					
					this.wrShow = true										
					if(item.is_presell == 1){ //如果是预售
						this.partOrderDeliveryWr = this.deliveryWr['1_'+item.activity_id] 
					}
					else{ //如果是普通商城订单
						this.partOrderDeliveryWr = this.deliveryWr[2]
					}					
				}else{
					this.$toast('请先选择提货点');
					return
				}								
			},
			//用户选择提货日期
			setWr(item){
				this.currentPartOrder.pickTime = item
				this.wrShow = false
			},
			
			//获取自提点班休日历
			getDeliveryWr(){
				this.request.postURL('/api/order/getDeliveryWrList',{
					delivery_id:this.branch.id,
					id:this.ids
				}).then((res)=>{
					this.deliveryWr = res.data.data.delivery_wr //获取提货点的提货日历
					this.discount =res.data.data.discount	 //设置折扣									
				}).catch( (err) =>{
				   console.log(err)
				  });
			},
	
			// 用户提交订单
			onSubmit(){	
				
				this.subDisabled = true;
				setTimeout(()=>{
					this.subDisabled = false;
				},1000);
				
				
				if(!this.branch.id){
					this.$toast('请选择自提点');
					return 
				};
				
				for(let i= 0;i<this.carts.length;i++){
					if(!this.carts[i].pickTime){
						this.$toast('请选择提货日期');
						return
					}
				}
				
				let detail =[];
				this.carts.map(item=>{		
					let idArr = item.item_list.map(i=>{
						return i.id
					})		
					let obj={
						id:idArr,
						pickup_time:item.pickTime.ymd_time,
						attach:item.attach ? item.attach :''
					}
					detail.push(obj)
				})
				//赠品id
				let giftItemIds = []
				if(this.giftItem.id){
					giftItemIds = this.giftItem.item_list.map(item=>{
						return item.id
					})
				}	
				const params = {
					branch_id:this.branch.id,
					detail:detail,
					reduction_id:this.reduceCount.id ? this.reduceCount.id : 0 ,//满减活动的id
					gift_item_id:giftItemIds //满赠活动的记录id
				}; 

				this.actOrderAsync(params)				
			},
			//获取购物车信息
			getActCartItem(){
				this.request.postURL('/api/cart/actCartItem',{
					id:this.ids,
				}).then((res)=>{
					this.carts = res.data.data
				}).catch( (err) =>{
				   console.log(err)
				  });
			},
			//点击查看更多商品详情
			getGoodsInfo(item){
				
				this.currentPartOrder = item
				this.goodsInfoShow = true
			},
			//获取符合条件的满赠
			getGiftItem(){
				let obj = {}
				if(!this.giftList){
					obj = {}
				}else{
					let price = this.reductionGift == '1' ? this.lastTotalPrice : this.cartTotalPrice //1为满减优先					
					let filterList = this.giftList.filter(item=> Number(price)  > Number(item.min_amount) )
					if(filterList.length == 0){
						obj = {}
					}else{
						obj = filterList[filterList.length-1]	
					}					
				}
				this.giftItem = obj
			}
		},
		mounted() {
			this.cartTotalPrice = this.$route.query.cartTotalPrice
			this.ids = JSON.parse(this.$route.query.detail)
			this.lastTotalPrice = this.$route.query.lastTotalPrice
			this.reductionGift = this.$route.query.reductionGift
			this.giftList = JSON.parse(this.$route.query.giftList)
			this.reduceCount = this.$route.query.reduceCount			
			this.getGiftItem()
			this.getActCartItem()
			
			
			
		}
	}
</script>

<style>
	.tl{
		text-align: left;
	}
	.wr-title{
		text-align: center; 
		color: red;
		margin: 20px;
		font-weight: 700;
	}
	.wr-button{
		width: 100%;
		border: none;
		border-top: 1px solid #ccc;
	}
	.red-color{
		color:red;
	}
	.van-card{
		background-color: #ffffff;
	}
</style>
